<app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>LISTA DE INCIDENTES</h1>
        </div>
        <br />
        <div>
            <button id="" class="primary-button" [routerLink]="['/incident']">
                <span class="button-content">
                    <mat-icon>add_circle</mat-icon> Agregar nuevo
                </span>
            </button>

            <button id="" class="primary-button" (click)="exportIncident()">
                <span class="button-content">
                    <mat-icon fontIcon="system_update_alt_24"
                        >system_update_alt_24</mat-icon
                    >
                    Exportar
                </span>
            </button>
            <div class="dropdown">
                <button class="primary-button">
                    <span class="button-content">
                        <mat-icon fontIcon="bar_chart_24">bar_chart_24</mat-icon
                        >Estadística
                    </span>
                </button>
                <div class="dropdown-content">
                    <mat-nav-list>
                        <a class="list" mat-list-item routerLink="/tables"
                            ><span class="button-content">
                                <mat-icon fontIcon="bar_chart_24"
                                    >bar_chart_24</mat-icon
                                >
                                Gráficos
                            </span></a
                        >
                        <a class="list" mat-list-item routerLink="/heat-map"
                            ><span class="button-content">
                                <mat-icon fontIcon="public_24"
                                    >public_24</mat-icon
                                >
                                Mapas
                            </span></a
                        >
                    </mat-nav-list>
                </div>
            </div>
        </div>
        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <div class="table-adjustable">
                <table
                    mat-table
                    [dataSource]="
                        (asyncIncident | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let incident">
                            <a
                                mat-icon-a
                                [matMenuTriggerFor]="menu"
                                aria-label="Acciones"
                                title="Acciones"
                            >
                                <mat-icon class="main-icon">menu</mat-icon>
                            </a>
                            <div class="dropdown-menu">
                                <mat-nav-list>
                                    <mat-menu #menu="matMenu" class="icon-menu">
                                        <a
                                            class="icon-button"
                                            mat-menu-item
                                            (click)="incidentDetails(incident)"
                                            title="Ver incidente"
                                        >
                                            <span class="text-span">
                                                <mat-icon class="icon-size"
                                                    >search</mat-icon
                                                >
                                                Ver incidente
                                            </span>
                                        </a>
                                        <a
                                            class="icon-button"
                                            mat-menu-item
                                            [routerLink]="[
                                                '/incident',
                                                incident.id
                                            ]"
                                            title="Editar"
                                            *ngIf="incident.secure === false"
                                        >
                                            <span class="text-span">
                                                <mat-icon class="icon-size"
                                                    >edit</mat-icon
                                                >
                                                Editar
                                            </span>
                                        </a>
                                        <a
                                            class="icon-button"
                                            mat-menu-item
                                            [routerLink]="[
                                                '/traking-incident',
                                                incident.id
                                            ]"
                                            title="Seguimiento"
                                            *ngIf="incident.secure === false"
                                        >
                                            <span class="text-span">
                                                <mat-icon class="icon-size"
                                                    >assignment</mat-icon
                                                >
                                                Seguimiento
                                            </span>
                                        </a>

                                        <a
                                            class="icon-button"
                                            mat-menu-item
                                            (click)="
                                                openEncryptDialog(incident)
                                            "
                                            title="Encriptar/Desencriptar"
                                        >
                                            <span class="text-span">
                                                <mat-icon class="icon-size"
                                                    >lock</mat-icon
                                                >
                                                Encriptar
                                            </span>
                                        </a>

                                        <a
                                            class="icon-button"
                                            mat-menu-item
                                            (click)="eliminate(incident)"
                                            appOnlysuperuser="/incident"
                                            title="Eliminar"
                                            *ngIf="incident.secure === false"
                                        >
                                            <span class="text-span">
                                                <mat-icon class="icon-size"
                                                    >delete</mat-icon
                                                >
                                                Eliminar
                                            </span>
                                        </a>
                                    </mat-menu>
                                </mat-nav-list>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef>Código</th>
                        <td mat-cell *matCellDef="let incident">
                            {{ incident.code }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="violence">
                        <th mat-header-cell *matHeaderCellDef>
                            Tipo_de_violencia
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            <ng-container
                                *ngIf="
                                    incident.violence?.length;
                                    else noViolence
                                "
                            >
                                <ul class="list-none p-0 m-0">
                                    <li *ngFor="let v of incident.violence">
                                        {{ v.name }}
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-template #noViolence>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="conflictRelated">
                        <th mat-header-cell *matHeaderCellDef>
                            Relación_con_el_conflicto
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            {{ incident.conflictRelated }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="phisicAgression">
                        <th mat-header-cell *matHeaderCellDef>
                            Agresión_física
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            {{ incident.phisicAgression ? 'Sí' : 'No' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>Descripción</th>
                        <td mat-cell *matCellDef="let incident">
                            <span *ngIf="!isExpanded(incident); else fullText">
                                {{ incident?.description | slice : 0 : 45 }}
                                <ng-container
                                    *ngIf="incident?.description?.length > 55"
                                    >…</ng-container
                                >
                            </span>

                            <ng-template #fullText>
                                {{ incident?.description }}
                            </ng-template>

                            <span
                                *ngIf="incident?.description?.length > 45"
                                class="see-more-link"
                                (click)="toggleExpand(incident)"
                                (keydown.enter)="toggleExpand(incident)"
                                (keydown.space)="toggleExpand(incident)"
                                tabindex="0"
                                role="link"
                                [attr.aria-expanded]="isExpanded(incident)"
                            >
                                {{
                                    isExpanded(incident)
                                        ? 'Ver menos'
                                        : 'Ver más'
                                }}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="witnessRelationship">
                        <th mat-header-cell *matHeaderCellDef>
                            Reportado_por:
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            {{ incident.witnessRelationship }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>
                            Fecha_del_suceso:
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            {{ incident.date | date:'yyyy-MM-dd'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef>
                            Fecha_de_registro:
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            {{ incident.createdAt }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="witnesses">
                        <th mat-header-cell *matHeaderCellDef>Testigo(s)</th>
                        <td mat-cell *matCellDef="let incident">
                            <ng-container
                                *ngIf="
                                    incident.witnesses?.length;
                                    else noWitness
                                "
                            >
                                <ul>
                                    <li *ngFor="let w of incident.witnesses">
                                        {{ w.identificationCode }} -
                                        {{ w.name }} {{ w.lastName }}
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-template #noWitness>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="victim">
                        <th mat-header-cell *matHeaderCellDef>Victima(s)</th>
                        <td mat-cell *matCellDef="let incident">
                            <ng-container
                                *ngIf="incident.victims?.length; else noVictim"
                            >
                                <ul>
                                    <li *ngFor="let v of incident.victims">
                                        {{ v.identificationCode }} -
                                        {{ v.name }} {{ v.lastName }}
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-template #noVictim>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="perpetror">
                        <th mat-header-cell *matHeaderCellDef>Victimario(s)</th>
                        <td mat-cell *matCellDef="let incident">
                            <ng-container
                                *ngIf="
                                    incident.perpetrors?.length;
                                    else noPerpetror
                                "
                            >
                                <ul class="list-none p-0 m-0">
                                    <li *ngFor="let p of incident.perpetrors">
                                        {{ p.identificationCode }} -
                                        {{ p.name }} {{ p.lastName }}
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-template #noPerpetror>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef>Ubicación</th>
                        <td mat-cell *matCellDef="let incident">
                            {{ incident.location?.city }}-{{
                                incident.address?.territory
                            }}-{{ incident.address?.authority }}-{{
                                incident.address?.street
                            }}-{{ incident.address?.number }}-{{
                                incident.address?.complement
                            }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="relationship">
                        <th mat-header-cell *matHeaderCellDef>
                            Relación_con_la_víctima:
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            <div
                                *ngIf="
                                    incident.perpetrorsMetadata?.length;
                                    else noData
                                "
                            >
                                <div
                                    *ngFor="
                                        let p of incident.perpetrorsMetadata
                                    "
                                >
                                    {{ p.relationship }}
                                </div>
                            </div>
                            <ng-template #noData>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="organization">
                        <th mat-header-cell *matHeaderCellDef>
                            Grupo_presunto_responsable:
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            <div
                                *ngIf="
                                    incident.perpetrorsMetadata?.length;
                                    else noData
                                "
                            >
                                <div
                                    *ngFor="
                                        let p of incident.perpetrorsMetadata
                                    "
                                >
                                    {{ p.organization }}
                                </div>
                            </div>
                            <ng-template #noData>No registra</ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="geoRef">
                        <th mat-header-cell *matHeaderCellDef>
                            Georreferenciación
                        </th>
                        <td mat-cell *matCellDef="let incident">
                            <a
                                class="enlace"
                                href="https://maps.google.com/?q={{
                                    incident.location?.geoRef?.latitude
                                }},{{ incident.location?.geoRef?.longitude }}"
                                target="_blank"
                            >
                                {{ incident.location?.geoRef?.latitude }},
                                {{ incident.location?.geoRef?.longitude }}
                            </a>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="file">
                        <th mat-header-cell *matHeaderCellDef>Archivo</th>
                        <td mat-cell *matCellDef="let incident">
                            <ng-container
                                *ngIf="hasFile(incident); else noFile"
                            >
                                <a
                                    href
                                    (click)="
                                        openFile(incident);
                                        $event.preventDefault()
                                    "
                                    style="
                                        cursor: pointer;
                                        text-decoration: underline;
                                    "
                                >
                                    {{ incident.fileAttach.fileName }}
                                </a>
                            </ng-container>
                            <ng-template #noFile
                                ><span>No disponible</span></ng-template
                            >
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>
        <pagination-controls
            (pageChange)="fetchIncident($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
